import {
  Box,
  Container,
  Grid,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import About from "../pages/About";
import Categories from "../pages/Categories";
import Footer from "../components/Footer";
import Header from "../components/Navbar";
import { Helmet } from "react-helmet";

// Özel tema oluşturma
const theme = createTheme({
  palette: {
    primary: {
      main: "#E3623B", // Turuncu-kırmızı
    },
    secondary: {
      main: "#FF6B3D", // Açık turuncu
    },
    background: {
      default: "#FFFFFF", // Beyaz
    },
  },
});

function Home() {
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>Anka Baskı - Profesyonel Tekstil Baskı Çözümleri</title>
        <meta
          name="description"
          content="Anka Baskı ile profesyonel tekstil baskı hizmetleri. Kaliteli, hızlı ve güvenilir çözümler için bizi tercih edin."
        />
        <meta
          name="keywords"
          content="tekstil baskı, dijital baskı, sublime baskı, transfer baskı, ankara tekstil"
        />
      </Helmet>

      <Header />

      <Box component="main">
        {/* Hero Section */}

        {/* Ana İçerik Bölümleri */}
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <About />
            </Grid>
            <Grid item xs={12}>
              <Categories />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
    </ThemeProvider>
  );
}

export default Home;
